export default __webpack_public_path__ + "static/media/frontpage_video.56156430.mp4";